import { render } from "./Top.vue?vue&type=template&id=4dc6ee26"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"
script.render = render

export default script